import React from 'react';
import classes from './Spacer.module.scss';


function Spacer(){
	return (
		<div className={classes.spacer} >
		
		
		</div>
	)
}

export default Spacer;